
import React from 'react';
import TreatmentItem from './TreatmentItem';
import { Treatment } from '@/data/treatmentData';

interface TreatmentListProps {
  treatments: Treatment[];
  category: 'dental' | 'cosmetic';
  onToggleTreatment: (id: string, category: 'dental' | 'cosmetic') => void;
  onPriceChange: (id: string, value: string, category: 'dental' | 'cosmetic') => void;
}

const TreatmentList: React.FC<TreatmentListProps> = ({
  treatments,
  category,
  onToggleTreatment,
  onPriceChange
}) => {
  return (
    <div className="space-y-1">
      {treatments.map(treatment => (
        <TreatmentItem 
          key={treatment.id}
          treatment={treatment}
          onToggle={(id) => onToggleTreatment(id, category)}
          onPriceChange={(id, value) => onPriceChange(id, value, category)}
        />
      ))}
    </div>
  );
};

export default TreatmentList;
